/* eslint-disable no-undefined */
import Composition from 'src/lib/HOC/Composition';
import { stripCurlyBraces } from 'src/lib/Utils/helpers';
import data from './data';
import Video from './index';

const { component, compositionFunction } = Composition(Video)<typeof data>(
  ({ rendering, fields, params }) => {
    return {
      autoplay: params?.Autoplay ? 1 : 0,
      closedCaptions: params?.['Enable Closed Captions'] ? 1 : undefined,
      modestBranding: params?.['Hide Youtube Icon'] ? 1 : undefined,
      relatedVideos: params?.['Disable related videos'] ? 0 : 1,
      headline: fields?.Headline,
      image: fields?.['Video Still'].value.src ? fields?.['Video Still'].value : undefined,
      url: fields?.['Video Link']?.value?.url,
      id: stripCurlyBraces(rendering.dataSource).toLowerCase(),
    };
  }
);

export { compositionFunction };
export default component;
